import { SidebarTrigger } from '@/components/organisms';
import { ProfilePopover } from '../profile-popover';
import { ProductTourHeaderButton } from '../product-tour-header-button';
import { ReferEarnHeaderButton } from '../refer-earn-header-button';
import { NotificationPopover } from '../notification-popover';
import SellytIcon from '@/assets/svg/sellyt-icon.svg?react';
import { Link } from 'react-router';
import { routes } from '@/lib/constants';

function LayoutHeader() {
  return (
    <div className="flex justify-between md:justify-end items-center w-full fixed top-0 right-0 left-0 md:left-[var(--sidebar-width)] md:pr-[var(--sidebar-width)] p-4 backdrop-blur-sm z-50">
      <Link to={routes.root}>
        <SellytIcon className="md:hidden size-8" />
      </Link>
      <div className="flex gap-2.5 items-center md:pr-4">
        <NotificationPopover />
        <ReferEarnHeaderButton />
        <ProductTourHeaderButton />
        <ProfilePopover />
        <SidebarTrigger className="md:hidden" />
      </div>
    </div>
  );
}

export { LayoutHeader };
